<template>
  <div>
      <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1200"
      :filename= "nomeArquivo"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf">
      <section slot="pdf-content">
        <div class="container-pdf">
          <div class="title-qma">
              {{qma === 2 ? 'PIVS - Procedimento de Inspeção e Verificação de Serviço' : qma === 1 ? 'PIT - Plano de Inspeção e Teste' : 'LV - Lista de Verificações'}}
          </div>
          <div class="header-qma">
              <div class="header-review">
                  <div class="itemAvaliacao">{{ qmaData.itemAvaliacao }}</div>
                  <div class="review-content">
                      <div class="review-title">Revisão:</div>
                      <div class="review-number">
                        <b class="ml-1">{{  qmaData.revisao }}</b>
                      </div>
                  </div>
              </div>
              <div class="header-dados">
                  <div class="left-container">
                      <div class="pivspes">
                          <div>{{qma === 2 ? 'Código PIVS' : qma === 1 ? 'Código PIT' : 'Código LV'}}:
                            <b class="ml-1">
                              {{ qmaData.codigoTemplate }}
                            </b>
                          </div>
                        </div>
                      <div v-if="qma === 2">PES:
                        <b class="ml-1">{{ qmaData.codPes }}</b>
                      </div>
                      <div style="display: flex; align-items: center; gap: 1rem; width: 100%">
                        <div class="d-flex">
                          Status :
                        </div>
                        <div style="display: flex;" :class="qmaData.statusQma === 0 ? 'status-pill-wip' : qmaData.statusQma === 1 ? 'status-pill-waiting' :  qmaData.statusQma === 2 ?
                          'status-pill-aproved' : 'status-pill-reproved'">{{ qmaData.descricaoStatus }}</div>
                      </div>
                    </div>
                  <div class="rigth-container">
                    <div>Período:
                      <b class="ml-1">{{ qmaData.dataCriacaoFormatada }}</b>
                    </div>
                    <div>Cód. Obra: <b class="ml-1"> {{ qmaData.referencia}}</b></div>
                  </div>
              </div>
              <div class="header-cabecalho" v-if="newProp && newProp.cabecalho && newProp.cabecalho.length > 0">
                <div v-for="(obj) in newProp.cabecalho" v-bind:key="obj.cabecalhoId" style="display: flex; flex-direction: row; gap: 0.5rem">
                  <div>{{ obj.descricao }}:</div>
                  <b>{{ obj.resposta }}</b>
                </div>
              </div>
          </div>
          <div class="content-instructions" v-if="newProp  && newProp.orientacao && newProp.orientacao.length > 0">
              <div class="titles-assessment">ORIENTAÇÕES</div>
              <div v-for="(obj, index) in newProp.orientacao" style="display: flex; gap: 0.5rem; flex-direction: column; padding: 1rem; border: 1px solid #f4F4f4" v-bind:key="obj.nivelPrioridade">
                <div style="display: flex; padding-bottom: 10px;">
                  {{ index + 1 + '. ' +  obj.descricao }}
                </div>
                <!-- Guard pelo base64, nao pela urlImagem: quando a URL existe mas o download
                     do base64 falha ou volta vazio, o src virava 'data:image/jpeg;base64,' sem
                     payload e o html2canvas aborta com "Error loading image" — o PDF nunca era
                     gerado. As outras <img> deste template ja usam v-if="obj.base64". -->
                <div v-if="obj.urlImagem !== null && obj.base64">
                  <img :src="'data:image/jpeg;base64,' + obj.base64" class="imgOrientacao">
                </div>
              </div>
          </div>
          <div v-if="qma === 1 && newProp && newProp.equipamento > 0" style="break-inside: avoid">
            <div class="titles-assessment">
              <div class="title-assessment-left">AVALIAÇÃO DO EQUIPAMENTO</div>
            </div>
            <div v-for="(obj) in newProp.equipamento" v-bind:key="obj.etapaId">
              <div style="break-inside: avoid">
                <div class="subtitle">
                  {{ obj.descricaoEtapa }}
                </div>
                <div class="equipItem" v-for="(item) in obj.subEtapa" v-bind:key="item.subEtapaId">
                  <div style="background-color: #F4F4F4; padding: 1rem;">
                    {{ (item.nivelPrioridadeSubEtapa+ 1) + '. ' +  item.descricaoSubEtapa }}
                  </div>
                  <div v-for="(element) in item.itens" v-bind:key="element.perguntaId">
                    <div style="display: flex; flex-direction: column; padding: 1rem;">
                      <div style="color: #1A1818;; font-size: 12px; font-style: normal; font-weight: 500; line-height: normal;">
                        {{element.nivelPrioridadePergunta + '' + element.descricaoPergunta }}
                      </div>
                      <div style="color: #4A4848; font-size: 12px; font-style: normal; font-weight: 400; line-height: normal;">
                        {{ element.resposta !== '' && element.resposta !== null && element.resposta !== undefined ? element.resposta : 'N/D' }}
                      </div>
                      <hr>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div v-if="newProp && newProp.preRequisito && newProp.preRequisito.length > 0">
              <div v-for="(obj, index) in newProp.preRequisito" v-bind:key="index" style="break-inside: avoid;">
                <div class="titles-assessment" >
                  <div class="title-assessment-left">{{ obj.descricaoSubEtapa }}</div>
                  <div class="title-assessment-right">Aprovação</div>
                </div>
                <div v-for="(item, index) in obj.itens" v-bind:key="index" style="border:1px solid #f4f4f4">
                  <div style="display: flex; align-items: center; break-inside: avoid; padding: 1rem 0; border-right: 1px solid #f4f4f4;border-left: 1px solid #f4f4f4;">
                    <div class="text-description">{{ index + 1 + '. ' }}{{ item.descricaoPergunta }}</div>
                    <div class="card-apr font-bold" style="padding: 0 0 3px 0"  :style="getStyle(item.avaliacao)"> {{ getLabel(item.avaliacao) }}</div>
                  </div>
                </div>
              </div>
            </div>
              <div class="content-assessment"  v-if="newProp && newProp.avaliacaoMetadado && newProp.avaliacaoMetadado.length > 0">
                  <div class="list-assessment">
                    <div v-for="(obj) in newProp.avaliacaoMetadado" v-bind:key="obj.nivelPrioridadeEtapa">
                      <div>
                        <div class="titles-assessment" style="break-inside: avoid;">
                          <div style="display: flex; width: 50%;">
                            <div class="title-assessment-left">{{ obj.descricaoEtapa }}</div>
                          </div>
                          <div style="display: flex; width: 50%; justify-content: center;">
                            <div v-for="(verif, index) in verificacaoList" v-bind:key="'data-'+index"
                              style="display: flex; flex-direction: row; width: 100%; justify-content: center; padding: 0 1rem;">
                              <span v-if="verif.data" style="color: #fff; font-size: 11px; font-family: 'Poppins'; font-weight: 500;">
                                {{ verif.data }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div v-for="(item) in obj.subEtapa" v-bind:key="item.nivelPrioridadeSubEtapa">
                          <div v-if="obj.metadado === false" style="break-inside: avoid;
                                                                    background-color: #F4F4F4;
                                                                    align-items: center;
                                                                    display: flex;
                                                                    width: 100%;
                                                                    padding: 0 1rem ;
                                                                    font-family: 'Poppins';
                                                                    font-size: 12px;
                                                                    font-style: normal;
                                                                    font-weight: 400;
                                                                    line-height: 27px;">
                            <div style="display: flex; width: 50%;">
                              <div class="title-assessment-left">{{ item.descricaoSubEtapa }}</div>
                            </div>
                            <div style="display: flex; width: 50%; justify-content: center; break-inside: avoid;">
                              <div v-for="(verif, index) in verificacaoList" v-bind:key="index"
                                style="display: flex; flex-direction: row; width: 100%; justify-content: center; padding:0 1rem; break-inside: avoid;" >
                                <div style="display: flex; flex-direction: row; align-items: center; justify-content: center; width: 100%;">
                                  Verif. {{ '0' + ((verif.verificacao || index) + 1) }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else class="titles-substages" style="break-inside: avoid">
                            <div style="display: flex;width: 100%;">
                              <div class="title-assessment-left">{{ item.descricaoSubEtapa }}</div>
                            </div>
                          </div>
                          <div v-if="obj.metadado === false" style="margin-bottom: 1rem;">
                            <div v-for="(data, index) in item.itens" v-bind:key="data.perguntaId" style=" height: 100%; border: 1px solid #F4F4F4">
                              <div style="display: flex; align-items: center; gap: 0 1rem;width: 100%; break-inside: avoid; height: 100%;">
                                <div style="display: flex;width: 50%; flex-direction: column;">
                                  <div style="display: flex; align-items: center; width: 100%;">
                                    <div class="avalue-description ml-1">{{ index + 1 + '. ' }}{{ data.descricaoPergunta }}</div>
                                  </div>
                                </div>
                                <div class="hist-avalue">
                                  <div v-for="(hist) in data.itensHistorico" v-bind:key="hist.nivelPrioridadePergunta"
                                  style="display: flex; flex-direction: row; justify-content: center; align-items: flex-start; border-left: 1px solid #F4F4F4; padding:1rem;  break-inside: avoid; width: 100%;" >
                                    <div class="avalue-hist ml-1 font-bold" style="padding: 0 0 3px 0"  :style="getStyle(hist.resposta)"> {{ getLabel(hist.resposta) }}</div>
                                  </div>
                                </div>
                              </div>
                              <!-- Foto sai pra QUALQUER avaliacao que tenha anexo, nao so reprovado (resposta == 1).
                                   Desde o ZOP-71 o mobile exige foto ao aprovar item que estava reprovado, e a foto
                                   de item OK nunca aparecia no PDF. Chamado #020395. -->
                              <div v-if="data.avaliacaoImagem && data.avaliacaoImagem.length" style="display: flex; flex-direction: row; justify-content: flex-start;  break-inside: avoid; break-after: avoid; break-before: avoid ;border: 1px solid #F4F4F4">
                                <div v-for="avaliacao in data.avaliacaoImagem" v-bind:key="avaliacao.anexoId" style="break-inside: avoid;  break-after: avoid; break-before: avoid">
                                  <img v-if="avaliacao.base64" :src="'data:image/jpeg;base64,' + avaliacao.base64" style="width: 250px; max-width: 250px; height: 200px; padding: 1rem; break-inside: avoid; break-after: avoid; break-before: avoid">
                                </div>
                              </div>
                              <!-- Observacao sai pra QUALQUER avaliacao, nao so reprovado (resposta == 1).
                                   Antes o gate era `data.resposta == 1`, entao obs de item aprovado / AR / N/A
                                   existia no banco e nunca aparecia no PDF. Chamado #20155 (ZOP-59).
                                   O v-if interno tambem estava quebrado (`!== null || !== undefined` e sempre
                                   verdadeiro) e imprimia o rotulo "Observacao:" vazio. -->
                              <div v-if="data.observacao" style="display: flex; flex-direction: row; justify-content: flex-start;  break-inside: avoid; break-after: avoid; break-before: avoid ;border: 1px solid #F4F4F4">
                                <div class="observation">Observação:
                                    <div class="ml-1"> {{ data.observacao }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-for="(data, index) in item.itens" v-bind:key="data.perguntaId">
                              <div style="display: flex; flex-direction: column; gap: 0 1rem; width: 100%; border: 1px solid #F4F4F4; break-inside: avoid;">
                                <div class="risco-font-detalhe " style="display: flex; flex-direction: row; gap: 1rem; break-inside: avoid" >
                                  <div style="padding: 14px  0  5px 14px;">
                                    {{index > 10 ? index + 1 : "0" + (index + 1)}}. {{data.descricaoPergunta}}
                                  </div>
                                </div>
                                <div class="risco-font-observacao">
                                  <div v-if="data.tipoCampo == 2" style="display: flex; flex-direction: column; break-inside: avoid;">
                                    <div class="mt-3" style="break-inside: avoid;">
                                      Mídias:
                                      <div class="observation" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center; width: 100%;break-inside: avoid;">
                                        <div v-for="(obj) in data.respostasMetadado" v-bind:key="obj.respostaId" class="icone-img" style="flex: 0 1 calc(33.33% - 10px); flex-direction: row; margin-bottom: 10px; break-inside: avoid;">
                                          <img v-if="obj.base64" :src="'data:image/jpeg;base64,' + obj.base64" style="width: 10rem; height: auto; object-fit: contain; border: 1px solid #ddd; border-radius: 5px; break-inside: avoid;">
                                          <!-- <div class="observation" v-if="obj.resposta !== null || obj.resposta !== undefined">Observação:
                                            <div class="ml-1"> {{ obj.resposta }}</div>
                                          </div> -->
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style="display: flex; flex-direction: column; break-inside: avoid;">
                                  <div class="ml-1" v-for="(resposta, index) in data.respostasMetadado" v-bind:key="resposta.respostaid">
                                    <div style="display: flex; align-items: baseline; padding: 1rem;" v-if=" (data.tipoCampo !== 2 && data.tipoCampo !== 4 && data.tipoCampo !== 5 )">
                                      <div style="padding:0.5rem">
                                        Resposta {{ index >= 9 ? '0' + (index + 1) : (index + 1) }}:
                                      </div>
                                      <div>
                                        {{  data.tipoCampo === 6 ? 'Faça o download na aba de mídias!' : resposta.resposta }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div style="color: black; width: 100%; font-family: 'Segoe UI'; color: #666666; font-size: 14px; display: flex; justify-content: flex-start; break-inside: avoid;">
                                  <div v-if="data.tipoCampo == 4" style="display: flex; gap: 0.5rem; align-items: center; padding: 0.5rem; color: #495057;text-decoration: none;margin: 1rem 0; flex-wrap: wrap; break-inside: avoid;">
                                    <div v-for="(obj, index) in  data.respostasMetadado" v-bind:key="index" class="icone-img" style="flex: 0 1 calc(33.33% - 10px); flex-wrap: wrap; break-inside: avoid;" :class="obj.selecionado == true ? 'bordaSelecionada': ''">
                                      <i :class="obj.selecionado == true ? 'fa fa-check' : ''" :style="obj.selecionado == true ? 'background-color:#008144;color:white; padding:5px; position: absolute; border-radius:0 0 5px  0' : '' " ></i>
                                      <img v-if="obj.base64" :src="'data:image/jpeg;base64,' + obj.base64" class="imgRepCheck" style="width: 100% ; border: 1px solid #ddd; border-radius: 5px;flex-wrap: wrap;display: flex; flex-direction: row; break-inside: avoid;">
                                    </div>
                                  </div>
                                  <div v-if="data.tipoCampo == 5"
                                      style="break-inside: avoid; break-before: avoid; display: flex; flex-direction: column; gap: 1rem; align-items: flex-start; padding: 1rem; color: #495057;text-decoration: none; display: flex; justify-content: flex-start;">
                                    <div style="display: flex; gap: 0.25rem; align-items: center" v-for="(obj, index) in  data.respostasMetadado" v-bind:key="index">
                                      <div :style="getCheckSelecionado(obj.selecionado)" :class="obj.selecionado === true ? 'fas fa-check' : ''"></div>
                                      <div :style="getColorSelecionado()">{{ obj.resposta }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <!-- Observacao geral do QMA — a que o usuario escreve no fim do preenchimento
                   no mobile. Chamado #20155 (ZOP-60): o texto era gravado e sincronizado, mas
                   nao era projetado em nenhum DTO do PDF, entao nunca aparecia no documento.
                   Vem de DadosPdfConsultaDTO.Observacao; no modo agrupado chega pelo spread
                   de `base` em buildPropFromCadeia (observacao do QMA selecionado). -->
              <div style="break-inside: avoid; page-break-inside: avoid;"
                   v-if="newProp && newProp.observacao">
                <div class="titles-assessment">
                  <div class="title-assessment-left">OBSERVAÇÃO</div>
                </div>
                <div style="padding: 1rem; font-family: 'Poppins'; font-size: 14px; color: #1A1818; white-space: pre-wrap; word-break: break-word;">
                  {{ newProp.observacao }}
                </div>
              </div>
              <div style="break-inside: avoid; page-break-inside: avoid;"
                   v-if="qmaData.statusQma === 1 || qmaData.statusQma === 2">
                <div class="titles-assessment">
                  <div class="title-assessment-left">APROVAÇÃO</div>
                </div>
                <div style="display: flex; gap: 2rem; padding: 1rem;">
                  <div style="flex: 1; font-family: 'Poppins'; font-size: 14px; color: #1A1818;">
                    <div style="font-weight: bold; color: #008148; margin-bottom: 0.5rem;">QMA - Engenheiro</div>
                    <div v-if="qmaData.engenheiroAprovadorId">
                      <div>Nome: {{ qmaData.engenheiroNome || 'N/D' }}</div>
                      <div>Data/Hora: {{ formatarDataAprovacao(qmaData.engenheiroDataAprovacao) }}</div>
                    </div>
                    <div v-else style="color: #9AA2A4;">Pendente</div>
                  </div>
                  <div style="flex: 1; font-family: 'Poppins'; font-size: 14px; color: #1A1818;">
                    <div style="font-weight: bold; color: #008148; margin-bottom: 0.5rem;">QMA - Coordenador</div>
                    <div v-if="qmaData.coordenadorAprovadorId">
                      <div>Nome: {{ qmaData.coordenadorNome || 'N/D' }}</div>
                      <div>Data/Hora: {{ formatarDataAprovacao(qmaData.coordenadorDataAprovacao) }}</div>
                    </div>
                    <div v-else style="color: #9AA2A4;">Pendente</div>
                  </div>
                </div>
              </div>
              <div style="break-inside: avoid; page-break-inside: avoid; page-break-before: always;"
                  v-if="newProp && newProp.assinatura && newProp.assinatura.length > 0 && newProp.assinatura.find( x => x.base64 !== '' && x.base64 !== null && x.base64 !== undefined)">
                <div class="titles-signatures">
                  <div class="title-signatures-left">ASSINATURAS</div>
                </div>
                <div style="display: flex; flex-wrap: wrap; gap: 1rem; width: 100%; padding: 1rem; page-break-inside: avoid;">
                  <div
                    v-for="(obj) in newProp.assinatura"
                    v-bind:key="obj.assinaturaId"
                    style="flex: 1 1 calc(33.33% - 1rem); max-width: calc(33.33% - 1rem); display: flex; flex-direction: column; align-items: center; gap: 1rem; page-break-inside: avoid;">
                    <img v-if="obj.base64" :src="'data:image/jpeg;base64,' + obj.base64" style="width: 250px; max-width: 250px; height: 200px; padding: 1rem; page-break-inside: avoid;">
                    <div style="page-break-inside: avoid;" v-if="obj.base64 !== ''">{{ obj.nome }} - {{ obj.tipoAssinatura }}</div>
                  </div>
                </div>
              </div>
          </div>
      </div>
      </section>
      </vue-html2pdf>
  </div>
</template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
import { loading } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../../../static/img/qma/cabecalho_qma_pdf.svg'

export default {
  name: 'tableInqueryQmaPivs',
  mixins: [ActionsForm],
  components: {
    HeadDetailsGama,
    VueHtml2pdf
  },
  props: ['qma', 'propPdf', 'selectedQma', 'dataGeracao'],
  data () {
    return {
      dataFormatada: null,
      dataRelatorio: null,
      codQma: null,
      qmaData: {},
      listPhoto: [],
      avaliacaoReprovada: null,
      listAvaliacaoUrl: [],
      opcaoSelecionada: {},
      listOpcao: [],
      perguntaOpcaoItem: null,
      imgSelecionado64: null,
      imgSelecionado: {},
      imgSelecionadoDescricao: null,
      listVerificacao: null,
      grouppergunta: [],
      newProp: {},
      listImg: null,
      verificacaoList: [{}, {}, {}, {}]
    }
  },

  watch: {
  },

  computed: {
    nomeArquivo () {
      if (!this.selectedQma) {
        return 'N/D'
      }
      const dataDeHoje = new Date()
      const dataFormatada = dataDeHoje.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
      return `QMA - ${this.qma === 0 ? 'LV' : this.qma === 1 ? 'PIT' : this.qma === 2 ? 'PIVS' : ''} - ${this.selectedQma.codigoTemplate} - ${dataFormatada}`
    }
  },
  mounted () {},
  methods: {
    async onLoad (value, obj, qma) {
      // Guard: o mixin ActionsForm chama onLoad() automaticamente no mounted sem args.
      // O onLoad real é disparado pelo InformaoesPdfQma do *Table.vue passando value+obj.
      // Sem este return, o fluxo gera "PDF vazio" no mounted e polui o console.
      if (!value || !obj) return
      this.qmaData = {...value}
      // Carregar dados de aprovação (dupla aprovação M1.6).
      //
      // PDF Agrupado: o backend (CRUDQMA.InformaoesPdfAprovacaoQma) entrega
      // `dados.aprovacao` em cada item da cadeia. Como cada revisão tem aprovação
      // própria e o documento agrupado representa o ESTADO ATUAL da cadeia, usamos
      // a aprovação do ÚLTIMO QMA (maior numeroRevisao). Isso resolve o caso de
      // pai reprovado + filho aprovado: a aprovação do filho aparece no PDF
      // agrupado mesmo quando o "value" passado para onLoad é o pai.
      //
      // PDF Individual / cadeia indisponível: cai no GetInfo (legado) usando o
      // próprio QMAId do `value`.
      let aprov = null
      if (obj && Array.isArray(obj.cadeia) && obj.cadeia.length > 0) {
        const ordenada = [...obj.cadeia].sort((a, b) => (a.numeroRevisao || 0) - (b.numeroRevisao || 0))
        const ultimo = ordenada[ordenada.length - 1]
        if (ultimo && ultimo.dados && ultimo.dados.aprovacao) {
          aprov = ultimo.dados.aprovacao
        }
        // statusQma do último também: a seção APROVAÇÃO no template usa
        // `qmaData.statusQma in (1,2)` como gate — se o pai está reprovado (3) e
        // o filho aprovado (2), o gate fica falso e a aprovação some do PDF.
        // Para o agrupado o status que importa é o atual, do último da cadeia.
        if (ultimo && ultimo.statusQMA != null) {
          this.qmaData.statusQma = ultimo.statusQMA
        }
      }

      if (aprov) {
        this.qmaData.engenheiroAprovadorId = aprov.engenheiroAprovadorId
        this.qmaData.engenheiroNome = aprov.engenheiroNome
        this.qmaData.engenheiroDataAprovacao = aprov.engenheiroDataAprovacao
        this.qmaData.coordenadorAprovadorId = aprov.coordenadorAprovadorId
        this.qmaData.coordenadorNome = aprov.coordenadorNome
        this.qmaData.coordenadorDataAprovacao = aprov.coordenadorDataAprovacao
      } else if (value && value.id) {
        try {
          const infoResp = await inqueryQmaRepository.GetInfo(value.id)
          if (infoResp && infoResp.data && infoResp.data.data && infoResp.data.data[0]) {
            const info = infoResp.data.data[0]
            this.qmaData.engenheiroAprovadorId = info.engenheiroAprovadorId
            this.qmaData.engenheiroNome = info.engenheiroNome
            this.qmaData.engenheiroDataAprovacao = info.engenheiroDataAprovacao
            this.qmaData.coordenadorAprovadorId = info.coordenadorAprovadorId
            this.qmaData.coordenadorNome = info.coordenadorNome
            this.qmaData.coordenadorDataAprovacao = info.coordenadorDataAprovacao
          }
        } catch (e) {
          console.warn('Não foi possível carregar dados de aprovação para o PDF', e)
        }
      }
      const defaultObj = {
        cabecalho: [],
        assinatura: [],
        pergunta: [],
        orientacao: [],
        equipamento: [],
        avaliacaoMetadado: [],
        avaliacaoReprovada: [],
        preRequisito: []
      }

      if (!obj) {
        obj = defaultObj
      }

      if (obj && Array.isArray(obj.cadeia) && obj.cadeia.length > 0) {
        this.newProp = this.buildPropFromCadeia(obj)
      } else {
        this.newProp = obj
      }

      await this.$nextTick()
      await this.waitForImagesAndContent()
      await this.generatePDF(value)
    },

    formatDataPdf (dataIso) {
      if (!dataIso) return ''
      try {
        const d = new Date(dataIso)
        if (isNaN(d.getTime())) return ''
        const dd = String(d.getDate()).padStart(2, '0')
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const yyyy = d.getFullYear()
        return `${dd}/${mm}/${yyyy}`
      } catch (e) {
        return ''
      }
    },
    buildPropFromCadeia (wrapper) {
      const ordenada = [...wrapper.cadeia].sort((a, b) => (a.numeroRevisao || 0) - (b.numeroRevisao || 0)).slice(0, 4)
      const selecionadoId = wrapper.qmaIdSelecionado
      const base = (ordenada.find(c => c.qmaId === selecionadoId) || ordenada[ordenada.length - 1]).dados || {}

      this.verificacaoList = ordenada.map((c, i) => ({
        verificacao: i,
        qmaId: c.qmaId,
        label: c.labelVerificacao || ('Verif. ' + String(i + 1).padStart(2, '0')),
        // Data de finalizacao (Termino) com fallback pra DataCriacao - backend ja resolve o fallback
        data: this.formatDataPdf(c.data)
      }))

      // Match cross-QMA:
      //  - Avaliacao (QMAPerguntasVerificacao) tem referenciaId que é o link compartilhado entre revisões
      //    (cada QMA tem seu próprio perguntaId, mas o referenciaId é o mesmo).
      //  - Etapa/subEtapa também podem mudar de id entre QMAs, então matchamos por descrição + nivelPrioridade
      //    como fallback quando o id não bate.
      const matchEtapa = (cadeiaItem, etapa) => {
        const etapas = (cadeiaItem.dados && cadeiaItem.dados.avaliacaoMetadado) || []
        return etapas.find(e => e.etapaId === etapa.etapaId) ||
          etapas.find(e => e.descricaoEtapa === etapa.descricaoEtapa && e.nivelPrioridadeEtapa === etapa.nivelPrioridadeEtapa)
      }
      const matchSub = (etapaC, sub) => {
        const subs = (etapaC && etapaC.subEtapa) || []
        return subs.find(s => s.subEtapaId === sub.subEtapaId) ||
          subs.find(s => s.descricaoSubEtapa === sub.descricaoSubEtapa && s.nivelPrioridadeSubEtapa === sub.nivelPrioridadeSubEtapa)
      }
      const matchItem = (subC, item) => {
        const itens = (subC && subC.itens) || []
        if (item.referenciaId) {
          const byRef = itens.find(p => p.referenciaId === item.referenciaId)
          if (byRef) return byRef
        }
        return itens.find(p => p.perguntaId === item.perguntaId) ||
          itens.find(p => p.descricaoPergunta === item.descricaoPergunta && p.nivelPrioridadePergunta === item.nivelPrioridadePergunta)
      }

      const ultimo = ordenada[ordenada.length - 1]
      const ultimoEtapas = (ultimo && ultimo.dados && ultimo.dados.avaliacaoMetadado) || []

      // Helper: achar o item equivalente (mesma etapa/sub/pergunta) no ÚLTIMO da cadeia.
      // Usado pelo merge de relatório fotográfico no agrupado.
      const findItemInUltimo = (etapa, sub, item) => {
        if (!ultimo || !ultimo.dados) return null
        const etapaU = matchEtapa(ultimo, etapa)
        if (!etapaU) return null
        const subU = matchSub(etapaU, sub)
        if (!subU) return null
        return matchItem(subU, item)
      }

      // Histórico por revisão (Verif.01-04) é reconstruído a partir da cadeia.
      //
      // Merges no AGRUPADO (cadeia com mais de 1 QMA):
      //
      //   1. respostasMetadado (relatório fotográfico): se o item do base está vazio,
      //      herda do ÚLTIMO filho. Base normalmente é o pai rev 0 que só tem estrutura
      //      do template graças ao LEFT JOIN (R7.1 backend).
      //
      //   2. avaliacaoImagem (fotos das atividades NOT OK): concatena as fotos de TODAS
      //      as revisões da cadeia para cada atividade (match por referenciaId/descrição).
      //      Dedup por urlImagem: quando um filho é criado o sistema copia AnexoQMA do pai
      //      mantendo o mesmo arquivoid, e a URL do S3 inclui o arquivoid no path — logo
      //      URLs iguais = mesmo arquivo físico = foto herdada, aparece uma vez só.
      //      Resultado: atividade que no pai tinha 1 foto e ganhou 1 nova no filho aparece
      //      com 2 fotos no agrupado (1 herdada + 1 nova), não 3 nem 1.
      //
      // Individual (cadeia.length === 1) não entra em nenhum merge — segue só com dados próprios.
      const ehAgrupado = ordenada.length > 1

      const mergeAvaliacaoImagem = (etapa, sub, item) => {
        if (!ehAgrupado) return item.avaliacaoImagem || []
        const vistas = new Set()
        const result = []
        ordenada.forEach(c => {
          const etapaC = matchEtapa(c, etapa)
          const subC = matchSub(etapaC, sub)
          const itemC = matchItem(subC, item)
          const lista = (itemC && itemC.avaliacaoImagem) || []
          lista.forEach(img => {
            // urlImagem é a chave canônica (contém o arquivoid físico). anexoId é fallback
            // só pra não perder fotos caso URL venha vazia em algum cenário inesperado.
            const chave = img.urlImagem || img.anexoId
            if (!chave || vistas.has(chave)) return
            vistas.add(chave)
            result.push(img)
          })
        })
        return result
      }

      const avaliacaoMerged = (base.avaliacaoMetadado || []).map(etapa => ({
        ...etapa,
        subEtapa: (etapa.subEtapa || []).map(sub => ({
          ...sub,
          itens: (sub.itens || []).map(item => {
            let respostasMetadado = item.respostasMetadado
            if (ehAgrupado && (!respostasMetadado || respostasMetadado.length === 0)) {
              const itemUltimo = findItemInUltimo(etapa, sub, item)
              if (itemUltimo && itemUltimo.respostasMetadado && itemUltimo.respostasMetadado.length > 0) {
                respostasMetadado = itemUltimo.respostasMetadado
              }
            }
            const avaliacaoImagem = mergeAvaliacaoImagem(etapa, sub, item)
            const historico = ordenada.map((c, i) => {
              const etapaC = matchEtapa(c, etapa)
              const subC = matchSub(etapaC, sub)
              const itemC = matchItem(subC, item)
              return {
                nivelPrioridadePergunta: i,
                verificacao: i,
                resposta: itemC ? itemC.resposta : null
              }
            })
            return { ...item, respostasMetadado, avaliacaoImagem, itensHistorico: historico }
          })
        }))
      }))

      // Safety net: etapas que só existem no ÚLTIMO da cadeia (cenário raríssimo onde
      // o pai não tem nem `QMATipoMetadado` criado no banco — diferente do caso comum
      // onde o template existe mas está sem respostas, que é tratado acima no merge
      // por item).

      const etapaIgual = (a, b) =>
        (a.etapaId && b.etapaId && a.etapaId === b.etapaId) ||
        (a.descricaoEtapa === b.descricaoEtapa && a.nivelPrioridadeEtapa === b.nivelPrioridadeEtapa)

      ultimoEtapas.forEach(etapaU => {
        if (avaliacaoMerged.some(e => etapaIgual(e, etapaU))) return
        // Etapa veio só do último — montar com itensHistorico da cadeia.
        const etapaMerged = {
          ...etapaU,
          subEtapa: (etapaU.subEtapa || []).map(subU => ({
            ...subU,
            itens: (subU.itens || []).map(itemU => ({
              ...itemU,
              itensHistorico: ordenada.map((c, i) => {
                const etapaC = matchEtapa(c, etapaU)
                const subC = matchSub(etapaC, subU)
                const itemC = matchItem(subC, itemU)
                return {
                  nivelPrioridadePergunta: i,
                  verificacao: i,
                  resposta: itemC ? itemC.resposta : null
                }
              })
            }))
          }))
        }
        avaliacaoMerged.push(etapaMerged)
      })

      avaliacaoMerged.sort((a, b) => (a.nivelPrioridadeEtapa || 0) - (b.nivelPrioridadeEtapa || 0))

      return {
        ...base,
        avaliacaoMetadado: avaliacaoMerged
      }
    },

    async waitForImagesAndContent () {
      // Aguardar imagens carregarem
      await this.waitForImages()

      // Aguardar renderização adicional
      await new Promise(resolve => setTimeout(resolve, 800))

      // Verificar se existem elementos com base64 ainda carregando
      await this.waitForBase64Images()
    },

    waitForBase64Images () {
      return new Promise((resolve) => {
        const base64Images = document.querySelectorAll('img[src^="data:image"]')
        let processedImages = 0
        const totalBase64Images = base64Images.length

        if (totalBase64Images === 0) {
          resolve()
          return
        }

        // Timeout de segurança: imagens base64 vazias (src='data:image/jpeg;base64,'
        // sem payload — vindo de QMA com metadado FOTO não preenchido) ficam com
        // naturalHeight=0 pra sempre e travariam o setTimeout recursivo indefinidamente.
        // 3s é mais que suficiente pra qualquer base64 legítimo já estar carregado.
        const safetyTimeout = setTimeout(() => resolve(), 3000)

        const tryFinish = () => {
          if (processedImages === totalBase64Images) {
            clearTimeout(safetyTimeout)
            setTimeout(resolve, 200)
          }
        }

        base64Images.forEach(img => {
          // src vazio (data:image/jpeg;base64, sem payload) é considerado "pronto"
          // imediatamente — não há nada pra esperar carregar.
          const isEmptyBase64 = !img.src || /^data:image\/[^;]+;base64,\s*$/.test(img.src)
          if (isEmptyBase64) {
            processedImages++
            tryFinish()
            return
          }
          if (img.complete && img.naturalHeight !== 0) {
            processedImages++
            tryFinish()
          } else {
            const checkImage = () => {
              if (img.complete && img.naturalHeight !== 0) {
                processedImages++
                tryFinish()
              } else if (img.complete && img.naturalHeight === 0) {
                // imagem broken (base64 corrupto ou outro motivo) — desiste dela
                processedImages++
                tryFinish()
              } else {
                setTimeout(checkImage, 50)
              }
            }
            checkImage()
          }
        })
      })
    },

    waitForImages () {
      return new Promise((resolve) => {
        const images = document.querySelectorAll('img')
        let loadedImages = 0
        const totalImages = images.length

        if (totalImages === 0) {
          resolve()
          return
        }

        images.forEach(img => {
          if (img.complete && img.naturalHeight !== 0) {
            loadedImages++
            if (loadedImages === totalImages) {
              resolve()
            }
          } else {
            img.onload = () => {
              loadedImages++
              if (loadedImages === totalImages) {
                resolve()
              }
            }
            img.onerror = () => {
              loadedImages++
              if (loadedImages === totalImages) {
                resolve()
              }
            }
          }
        })

        // Timeout de segurança
        setTimeout(() => {
          resolve()
        }, 3000)
      })
    },

    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    async generatePDF (obj) {
      if (!this.hasValidContent()) {
        return
      }
      if (this.$refs.html2Pdf) {
        await this.$refs.html2Pdf.generatePdf()
      }
    },

    hasValidContent () {
      if (!this.qmaData || !this.newProp) {
        return false
      }
      const len = (arr) => Array.isArray(arr) ? arr.length : 0
      return len(this.newProp.cabecalho) > 0 ||
        len(this.newProp.orientacao) > 0 ||
        len(this.newProp.avaliacaoMetadado) > 0 ||
        len(this.newProp.preRequisito) > 0 ||
        len(this.newProp.equipamento) > 0 ||
        len(this.newProp.assinatura) > 0
    },

    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [1.2, 0, 0.5, 0]
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.3, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'bold')
          pdf.setFontSize(10)
          pdf.text(
            this.nomeArquivo,
            0.5,
            pdf.internal.pageSize.getHeight() - 0.1
          )
          pdf.text(
            'Pág ' + i + ' de ' + totalPages,
            7,
            pdf.internal.pageSize.getHeight() - 0.1
          )
        }
      }).save()
      loading.pop()
    },
    getLabel (value) {
      switch (value) {
        case 0:
          return this.qma === 2 ? 'A' : 'OK'
        case 1:
          return this.qma === 2 ? 'R' : 'NOK'
        case 2:
          return this.qma === 2 ? 'AR' : 'N/A'
        // Chamado #20155 (ZOP-69): o N/A (valor 3) passou a existir tambem no
        // PIVS. Antes o 3 nunca chegava num PIVS, entao agrupar com o 2 era
        // inofensivo; agora agrupado o PIVS imprimia 'AR' no lugar de 'N/A'.
        case 3:
          return 'N/A'
        default:
          return null
      }
    },
    getStyle (value) {
      switch (value) {
        case 0:
          return { backgroundColor: '#CBE9CF', color: '#1C6228' }
        case 1:
          return { backgroundColor: 'rgb(255, 205, 205)', color: 'rgb(136, 22, 22)' }
        case 2:
          return { backgroundColor: 'rgb(255, 216, 187)', color: 'rgb(188, 72, 7)' }
        // N/A tem cor propria (cinza), igual ao botao N/A do app.
        case 3:
          return { backgroundColor: 'rgb(226, 226, 226)', color: 'rgb(90, 90, 90)' }
        default:
          return {}
      }
    },
    getCheckSelecionado (value) {
      if (value === true) {
        return {
          backgroundColor: '#B7E5BF',
          color: '#133B1A',
          width: '15px',
          height: '15px',
          borderRadius: '3px',
          border: '1px solid #D0D0D0'
        }
      } else if (value === false) {
        return {
          backgroundColor: '#B7E5BF',
          color: '#133B1A',
          width: '15px',
          height: '15px',
          borderRadius: '3px',
          border: '1px solid #D0D0D0'
        }
      } else {
        return {}
      }
    },
    formatarDataAprovacao (date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getColorSelecionado (value) {
      if (value === true) {
        return {
          color: '#133B1A',
          fontSize: '14px'
        }
      } else if (value === false) {
        return {
          color: '#133B1A',
          fontSize: '14px'
        }
      } else {
        return {}
      }
    }
  }
}

</script>

<style scoped>

.header-cabecalho {
  border-radius: 10px;
  background: #F4F4F4;
  gap: 10px;
  padding: 10px 15px;

  /* Add grid layout for two columns */
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns of equal width */
  column-gap: 15px; /* Space between columns */
  row-gap: 10px; /* Space between rows */
}

.header-cabecalho div {
  display: flex;
  justify-content: flex-start /* Space between description and response */
}

  .hist-avalue{
    display: flex;
    justify-content: flex-start;
    width: 50%;
    break-inside: avoid;
    align-items: flex-start;
    height: max-content;
    padding: 0;
  }
  .bordaSelecionada {
    border: 5px solid #008144;
    border-radius: 10px;
    width: calc(33.33% - 10px);
  }
  .subtitle {
    width: 100%;
    color: #008148;
    background-color: #F4F4F4;
    font-size: 14px;
    font-family: "Poppins";
    display: flex;
    align-items: center;
    padding: 0 1rem;
  }
  .equipItem{
    display: flex;
    /* align-items: center; */
    flex-direction: column;
    font-size: 14px;
    font-family: "Poppins";
    color:#1A1818;
    break-inside: avoid;
    border: 1px solid #f4f4f4;
    height: 100%;
  }
  .observation{
    margin-left: 1rem;
    display: flex;
    gap: 1rem;
  }
  .description-obs{
    display: flex;
    flex-direction: column;
    padding-right: 1rem;
  }
  .risco-font-observacao{
    color: #9AA2A4;
    font-family: 'Segoe UI';
    font-size: 12px;
    padding: 0 0 0 8px;
    width: 100%;
    display: flex;
  }
.imgRepCheck{
  width: 12rem;
  height: 15rem;
  border-radius:  5px;
  break-inside: avoid;
}
.imgOrientacao{
  width: 12rem;
  height: 8rem;
  border-radius:  5px;
  break-inside: avoid;
}
  .icone-img {
    border-radius: 10px;
    gap: 3rem;
  }
  .font-bold {
    font-size: 14px;
    font-weight: bold;
    color:#666666;
  }
  .card-apr{
    font-size: 12px;
    font-family: 'Segoe UI';
    border-radius: 8px;
    width: 3rem;
    height: fit-content;
    display: flex;
    justify-content: center;
  }
  .avalue-hist{
    font-size: 12px;
    font-family: 'Segoe UI';
    border-radius: 8px;
    width: 3rem;
    height: fit-content;
    display: flex;
    justify-content: center;
  }
.text-description{
padding: 14px;
width: 85%;
}
.avalue-description{
padding: 1.5rem;
width: 100%;
}
.titles-substages{
background-color: #F4F4F4;
align-items: center;
display: flex;
padding: 0 14px;
font-family: 'Poppins';
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 27px;
}
.list-assessment, .list-signatures {
}
.title-assessment-left, .list-signatures-left{
  width: 85%;
}
.title-assessment-right{
  display: flex;
  align-items: center;
}
.titles-assessment, .titles-signatures {
  padding: 0 16px;
  align-items: center;
  display: flex;
  background: #2E973D;
  color: #fff;
  font-family: 'Poppins';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  width: 100%;
}
.title-instruction {
  color: #1A1818;
  font-family: 'Poppins';
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 27px;
}
/* .header-cabecalho{
  border-radius: 10px;
  background: #F4F4F4;
  gap: 10px;
  padding: 10px 15px;
} */
.header-dados{
  display: flex;
  gap: 10px;
}
.pivspes{
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
}
.left-container{
  display: flex;
  width: 100%;
  padding: 10px 15px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 10px;
  background: #F4F4F4;
  gap: 10px;
}
.rigth-container{
  display: flex;
  width: 100%;
  padding: 10px 15px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 10px;
  background: #F4F4F4;
  gap: 10px;
}
.itemAvaliacao {
  width: 85%;
  color:#1A1818;
  font-family: 'Poppins';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: flex;
  border-right: solid 1px #E1E1E1;
}
.review-content {
width: 15%;
  display: flex;
  justify-content: center;
  color:#1A1818;
  font-family: 'Poppins';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  }
.header-review{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  background: #F4F4F4;
}
.header-qma{
  gap: 10px;
  display: flex;
  width: 100%;
  flex-direction: column;
}
.title-qma {
  display: flex;
  justify-content: center;
  color:#1A1818;
  text-align: center;
  font-family: 'Poppins';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 27px; /* 168.75% */
}
/*  */
.title-checklist,
.title-risk,
.title-medias,
.title-signature {
font-size: 16px;
color: #008144;
font-family: 'Segoe UI';
font-weight: bold;
break-inside: avoid;
break-before: avoid;
}
.lfAnalysis {
display: flex;
flex-direction: row;
}
.statusTemplate {
font-size: 14px;
font-weight: bold;
}
.analysisRisk{
display: flex;
align-items: center;
flex-direction: row;
background-color: #F4F4F4;
padding: 1rem;
gap: 1rem;
border-radius: 10px;
justify-content: space-between;
}
.iconHat{
background-color: #e8e8e8;
border-radius: 5px;
}
.titleNumberApr{
font-family: 'Segoe UI';
font-size: 18px;
font-weight: bold;
display: flex;
align-items: center;
justify-content: flex-start;
}
.addressApr, .addressDiv{
display: flex;
}

.responsableApr,
.dateExpire,
.dateApr {
display: flex;
}

.dateResponsable{
display: flex;
gap: 1rem;
justify-content: space-between;
}
.font-info {
font-weight: bold;
}
.font-title, .font-info {
font-family: 'Segoe UI';
font-size: 14px;
}
.revisao{
color: #008144;
font-weight: bold;
font-family: 'Segoe UI';
font-size: 16px;
}
.numberApr, .numbreRevisao{
display: flex;
align-items: center;
}
.numbreRevisao {
justify-content: flex-end;
}
.title-template,
/* .analysis-template, */
.container_ocorrencias,
.causa_raiza_result,
.title-signature,
.signaturelists{
break-inside: avoid;
}
.checklist {
break-after: avoid;
}
.container-pdf{
padding: 2rem;
display: flex;
flex-direction: column;
gap: 1rem;
border-radius: 10px;
font-family: 'Segoe UI';
font-weight: 500;
}
.title-template {
display: flex;
flex-direction: column;
background-color: #F4F4F4;
padding: 1rem;
gap: 1rem;
border-radius: 10px;
}
.info-pdf {
display: flex;
}
.container_ocorrencias_filtradas {
width: 100%;
height: 2rem;
border-radius: 5px 5px 0 0;
background: #008144;
display: flex;
justify-content: space-around;
}
.font{
      color: #FFF;
      font-family:'Segoe UI';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px;
  }
  .numero_oce,
  .tecnico_oce,
  .engenheiro_oce,
  .causa_raiza {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .numero_oce_result,
  .tecnico_oce_result,
  .engenheiro_oce_result {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .font_result {
      color: #1A1818;
      font-family:'Segoe UI';
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 27px;
  }
  .container_ocorrencias {
    width: 100%;
    margin: 1rem 0;
    display: flex;
    justify-content: space-around;
  }
  .causa_raiza_result {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .status-pill-wip{
  display: flex;
  font-size: 14px !important;
  padding: 1rem;
  width: 14rem;
  height: 30px;
  color: #6a6a6a;
  font-weight: bold;
  font-family: 'Segoe UI';
  justify-content: center;
  padding-left: 10%;
  padding-right: 10%;
  border-radius: 25px;
  align-items: center;
  background: #c0c0c0;
}
.status-pill-aproved {
  display: flex;
  font-size: 14px !important;
  padding: 1rem;
  width: 14rem;
  height: 30px;
  color: #133B1A;
  font-weight: bold;
  font-family: 'Segoe UI';
  justify-content: center;
  padding-left: 10%;
  padding-right: 10%;
  border-radius: 25px;
  align-items: center;
  background: #CBE9CF;
}
.status-pill-waiting {
  display: flex;
  font-size: 14px !important;
  padding: 1rem;
  width: 14rem;
  height: 30px;
  color: #003789;
  font-weight: bold;
  font-family: 'Segoe UI';
  justify-content: center;
  padding-left: 10%;
  padding-right: 10%;
  border-radius: 25px;
  align-items: center;
  background: #D4EEFD;
}
.status-pill-reproved {
  display: flex;
  font-size: 14px !important;
  padding: 1rem;
  width: 14rem;
  height: 30px;
  color: #AB0101;
  font-weight: bold;
  font-family: 'Segoe UI';
  justify-content: center;
  padding-left: 10%;
  padding-right: 10%;
  border-radius: 25px;
  align-items: center;
  background: #FFD9D9;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/inqueryPdfQma/inqueryPdfQma.vue